/**
 * Notify Admin OPS when Cleaner Hub has low stock or a turnover completes.
 * Invokes the notify-ops-hub edge function (server holds Admin webhook secret).
 */
import { supabase } from "@/integrations/supabase/client";

export type OpsHubEvent = "inventory_low_stock" | "cleaning_complete";

export async function notifyOpsHub(input: {
  event: OpsHubEvent;
  propertyId: string;
  cleaningTaskId?: string | null;
  items?: Array<{ item_name: string; detail: string }>;
  detail?: string | null;
}): Promise<{ ok: boolean; skipped?: boolean; error?: string }> {
  const propertyId = (input.propertyId || "").trim();
  if (!propertyId) return { ok: false, error: "propertyId required" };

  try {
    const { data, error } = await supabase.functions.invoke("notify-ops-hub", {
      body: {
        event: input.event,
        propertyId,
        cleaningTaskId: input.cleaningTaskId ?? null,
        items: input.items ?? [],
        detail: input.detail ?? null,
      },
    });
    if (error) {
      console.warn("[notifyOpsHub]", error.message);
      return { ok: false, error: error.message };
    }
    const result = data as {
      ok?: boolean;
      skipped?: boolean;
      error?: string;
    } | null;
    if (result?.skipped) return { ok: true, skipped: true };
    if (result?.ok) return { ok: true };
    return { ok: false, error: result?.error ?? "notify-ops-hub failed" };
  } catch (err) {
    const message = err instanceof Error ? err.message : "notify failed";
    console.warn("[notifyOpsHub]", message);
    return { ok: false, error: message };
  }
}
